<ng-container ntapFilterViewProvider [viewName]="currentViewName" [viewState]="currentViewStateFilter">
    <ng-container appInMemoryListViewProvider [viewName]="currentViewName" [viewState]="currentViewState">
        <app-editable-table style="display: flex;" [parentItem]="parentItem$"
            [readOnly]="inputParam.attributeMetadata.read_only" relToParentItemKey="entitet_id" [showInOverlay]="showTableInOverlay"></app-editable-table>
    </ng-container>
</ng-container>